import {
  format as dateFnsFormat,
  isValid as dateFnsIsValid,
  parse as dateFnsParse,
} from "date-fns";
import { ptBR as locale } from "date-fns/locale";

export function dateParse(value: any, format: string = null): Date {
  if (!value) return value;
  if (value instanceof Date) return value;

  const date = !format
    ? new Date(value)
    : dateFnsParse(value, format, new Date(), { locale });
  if (!dateFnsIsValid(date)) return value;

  return date;
}

export function dateFormat(date: Date, format: string = "dd/MM/yyyy"): string {
  return dateFnsFormat(date, format, { locale });
}
